import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=45ee2106&scoped=true&"
import script from "./Product.vue?vue&type=script&setup=true&lang=js&"
export * from "./Product.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=45ee2106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee2106",
  null
  
)

export default component.exports